import { useEffect, useState } from 'react'

export const useCounterAnimation = (
	targetValue: number,
	duration = 1000,
	shouldAnimate = false
): number => {
	const [animatedValue, setAnimatedValue] = useState(targetValue)

	useEffect(() => {
		if (!shouldAnimate) {
			setAnimatedValue(targetValue)
			return
		}
		if (animatedValue === targetValue) return

		const startTime = Date.now()
		const startValue = animatedValue
		const endValue = targetValue

		const animate = () => {
			const elapsed = Date.now() - startTime
			const progress = Math.min(elapsed / duration, 1)
			const easeOutQuart = 1 - Math.pow(1 - progress, 4)
			const currentValue = Math.round(startValue + (endValue - startValue) * easeOutQuart)

			setAnimatedValue(currentValue)
			if (progress < 1) {
				requestAnimationFrame(animate)
			}
		}

		requestAnimationFrame(animate)
	}, [targetValue, shouldAnimate, animatedValue, duration])

	return animatedValue
}
